import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_themed_image = _resolveComponent("themed-image")

  return (_openBlock(), _createElementBlock("div", {
    title: $options.platformName,
    class: "gfu-header-logo",
    "data-qa": "main-navbar:Logo"
  }, [
    _createElementVNode("a", { href: $options.url }, [
      _createVNode(_component_themed_image, {
        class: "gfu-header-logo__icon",
        src: "/content/images/site-icon.svg",
        alt: $options.platformName
      }, null, 8 /* PROPS */, ["alt"]),
      _createVNode(_component_themed_image, {
        class: "gfu-header-logo__full",
        src: "/content/images/static/logo/site-logo.svg",
        alt: $options.platformName
      }, null, 8 /* PROPS */, ["alt"])
    ], 8 /* PROPS */, _hoisted_2)
  ], 8 /* PROPS */, _hoisted_1))
}